var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 20,
    height: 39,
    viewBox: "0 0 20 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.296875 0.84375H3.05561C3.82586 0.84375 4.50179 1.04024 5.0834 1.43322C5.66502 1.82621 6.08944 2.37638 6.35666 3.08375L19.9617 38.2871H17.203C16.5113 38.2871 15.8433 38.0828 15.1988 37.6741C14.5543 37.2811 14.0748 36.6916 13.7605 35.9056L0.296875 0.84375Z",
    fill: "#5FB4D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlash);
export default __webpack_public_path__ + "static/media/slash.1c0f137b52023d216866859da9d346a7.svg";
export { ForwardRef as ReactComponent };